import { useState } from "react"; 
import Datepicker from "react-tailwindcss-datepicker";
import { DateValueType } from "react-tailwindcss-datepicker";

interface DatePickerProps {
    handleDateChange: (date: DateValueType) => void;
}

const DatePickerComponent: React.FC<DatePickerProps> = ({handleDateChange}) => { 

    const [value, setValue] = useState<DateValueType>({ 
        startDate: null, 
        endDate: null
    });



    return (
        <Datepicker
            value={value} 
            onChange={(newValue) => {
                setValue(newValue);
                handleDateChange(newValue);
            }}
            showShortcuts={true}
            inputClassName="text-base md:text-sm relative border-2 rounded-xl h-[38px] transition-all duration-300 py-2.5 pl-4 pr-14 w-full border-gray-300 dark:bg-slate-800 dark:text-white/80 dark:border-slate-600 rounded-lg tracking-wide font-light placeholder-gray-400 bg-white focus:ring disabled:opacity-40 disabled:cursor-not-allowed focus:border-blue-500 focus:ring-blue-500/20"
            configs={{
                shortcuts: {
                    today: {
                        text: "Today",
                        period: {
                            start: new Date(),
                            end: new Date()
                        }
                    },
                    next7Days: {
                        text: "This Week",
                        period: {
                            start: new Date(new Date().setDate(new Date().getDate() )),
                            end: new Date(new Date().setDate(new Date().getDate() + 6))
                        }
                    },
                    thisMonth: {
                        text: "This Month",
                        period: {
                            start: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                            end: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
                        }
                    },
                },
                footer: {
                    cancel: "CText",
                    apply: "AText"
                }
            }}

        /> 
    );
};

export default DatePickerComponent;
